






































import { ConfigEditor } from './config-editor';
export default ConfigEditor;
